/**
 * Child Theme - Scripts
 * File: custom-javascript.js
 * Description: file Js principale para el tema Child, qui vengono inizializzati i moduli js.
 *
 */

import StickyNavbar from "./modules/sticky-navbar";
import { initHeroSlider } from "./modules/init-hero-slider";
import { initScrollReveal } from "./modules/scroll-reveal";

jQuery(document).ready(function ($) {
    console.log("Theme Child → DOM pronto 👍");

    // Inizializza la Navbar sticky
    StickyNavbar.initialize("mainNavbar");

    // Inizializza lo slider Hero, attivato solo se necessario
    initHeroSlider();

    // Inizializza le animazioni allo scroll (Intersection Observer)
    initScrollReveal();
});
